import React from "react";
import { cn } from "../../utils/cn";

/**
 * Small status Badge
 * variant: default | info | success | warning | danger | outline
 */
const styles = {
  default:
    "bg-[rgb(var(--afrimed-muted))] text-[rgb(var(--afrimed-foreground))]",
  info:
    "bg-[rgb(var(--afrimed-secondary))]/15 text-[rgb(var(--afrimed-secondary))]",
  success:
    "bg-[rgb(var(--afrimed-success))]/15 text-[rgb(var(--afrimed-success))]",
  warning:
    "bg-[rgb(var(--afrimed-warning))]/15 text-[rgb(var(--afrimed-warning))]",
  danger:
    "bg-[rgb(var(--afrimed-error))]/15 text-[rgb(var(--afrimed-error))]",
  outline:
    "bg-transparent border border-[rgb(var(--afrimed-outline))] text-[rgb(var(--afrimed-foreground))]",
};

export default function Badge({ children, variant = "default", className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        styles[variant],
        className
      )}
    >
      {children}
    </span>
  );
}